import { render, staticRenderFns } from "./InfowindowComponent.vue?vue&type=template&id=7be5e859"
import script from "./InfowindowComponent.vue?vue&type=script&lang=ts"
export * from "./InfowindowComponent.vue?vue&type=script&lang=ts"
import style0 from "./InfowindowComponent.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/app/components/base/Icon/Icon.vue').default,Headline: require('/app/components/base/Headline/Headline.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default})
